"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaveUnidad = exports.ClaveProdServ = exports.UsoCFDI = exports.TipoRelacion = exports.TipoFactor = exports.TipoDeComprobante = exports.RegimenFiscal = exports.Periodicidad = exports.Pais = exports.ObjetoImp = exports.Moneda = exports.MetodoPago = exports.Meses = exports.Impuesto = exports.FormaPago = exports.Exportacion = exports.Estado = void 0;
var Estado;
(function (Estado) {
    Estado["Aguascalientes"] = "AGU";
    Estado["BajaCalifornia"] = "BCN";
    Estado["BajaCaliforniaSur"] = "BCS";
    Estado["Campeche"] = "CAM";
    Estado["Chiapas"] = "CHP";
    Estado["Chihuahua"] = "CHH";
    Estado["Coahuila"] = "COA";
    Estado["Colima"] = "COL";
    Estado["CiudadDeMexico"] = "CMX";
    Estado["Durango"] = "DUR";
    Estado["Guanajuato"] = "GUA";
    Estado["Guerrero"] = "GRO";
    Estado["Hidalgo"] = "HID";
    Estado["Jalisco"] = "JAL";
    Estado["EstadoDeMexico"] = "MEX";
    Estado["Michoacan"] = "MIC";
    Estado["Morelos"] = "MOR";
    Estado["Nayarit"] = "NAY";
    Estado["NuevoLeon"] = "NLE";
    Estado["Oaxaca"] = "OAX";
    Estado["Puebla"] = "PUE";
    Estado["Queretaro"] = "QUE";
    Estado["QuintanaRoo"] = "ROO";
    Estado["SanLuisPotosi"] = "SLP";
    Estado["Sinaloa"] = "SIN";
    Estado["Sonora"] = "SON";
    Estado["Tabasco"] = "TAB";
    Estado["Tamaulipas"] = "TAM";
    Estado["Tlaxcala"] = "TLA";
    Estado["Veracruz"] = "VER";
    Estado["Yucatan"] = "YUC";
    Estado["Zacatecas"] = "ZAC";
    Estado["Alabama"] = "AL";
    Estado["Alaska"] = "AK";
    Estado["Arizona"] = "AZ";
    Estado["Arkansas"] = "AR";
    Estado["California"] = "CA";
    Estado["CarolinaDelNorte"] = "NC";
    Estado["CarolinaDelSur"] = "SC";
    Estado["Colorado"] = "CO";
    Estado["Connecticut"] = "CT";
    Estado["DakotaDelNorte"] = "ND";
    Estado["DakotaDelSur"] = "SD";
    Estado["Delaware"] = "DE";
    Estado["Florida"] = "FL";
    Estado["Georgia"] = "GA";
    Estado["Hawai"] = "HI";
    Estado["Idaho"] = "ID";
    Estado["Illinois"] = "IL";
    Estado["Indiana"] = "IN";
    Estado["Iowa"] = "IA";
    Estado["Kansas"] = "KS";
    Estado["Kentucky"] = "KY";
    Estado["Luisiana"] = "LA";
    Estado["Maine"] = "ME";
    Estado["Maryland"] = "MD";
    Estado["Massachusetts"] = "MA";
    Estado["Michigan"] = "MI";
    Estado["Minnesota"] = "MN";
    Estado["Misisipi"] = "MS";
    Estado["Misuri"] = "MO";
    Estado["Montana"] = "MT";
    Estado["Nebraska"] = "NE";
    Estado["Nevada"] = "NV";
    Estado["NuevaJersey"] = "NJ";
    Estado["NuevaYork"] = "NY";
    Estado["NuevoHampshire"] = "NH";
    Estado["NuevoMexico"] = "NM";
    Estado["Ohio"] = "OH";
    Estado["Oklahoma"] = "OK";
    Estado["Oregon"] = "OR";
    Estado["Pensilvania"] = "PA";
    Estado["RhodeIsland"] = "RI";
    Estado["Tennessee"] = "TN";
    Estado["Texas"] = "TX";
    Estado["Utah"] = "UT";
    Estado["Vermont"] = "VT";
    Estado["Virginia"] = "VA";
    Estado["VirginiaOccidental"] = "WV";
    Estado["Washington"] = "WA";
    Estado["Wisconsin"] = "WI";
    Estado["Wyoming"] = "WY";
    Estado["Ontario"] = "ON";
    Estado["Quebec"] = "QC";
    Estado["NuevaEscocia"] = "NS";
    Estado["NuevoBrunswick"] = "NB";
    Estado["Manitoba"] = "MB";
    Estado["ColumbiaBritanica"] = "BC";
    Estado["IslaDelPrincipeEduardo"] = "PE";
    Estado["Saskatchewan"] = "SK";
    Estado["Alberta"] = "AB";
    Estado["TerranovaYLabrador"] = "NL";
    Estado["TerritoriosDelNoroeste"] = "NT";
    Estado["Yukon"] = "YT";
    Estado["Nunavut"] = "UN";
})(Estado = exports.Estado || (exports.Estado = {}));
var Exportacion;
(function (Exportacion) {
    Exportacion["NoAplica"] = "01";
    Exportacion["Definitiva"] = "02";
    Exportacion["Temporal"] = "03";
})(Exportacion = exports.Exportacion || (exports.Exportacion = {}));
var FormaPago;
(function (FormaPago) {
    FormaPago["Efectivo"] = "01";
    FormaPago["ChequeNominativo"] = "02";
    FormaPago["TransferenciaElectronicaDeFondos"] = "03";
    FormaPago["TarjetaDeCredito"] = "04";
    FormaPago["MonederoElectronico"] = "05";
    FormaPago["DineroElectronico"] = "06";
    FormaPago["ValesDeDespensa"] = "08";
    FormaPago["DacionEnPago"] = "12";
    FormaPago["PagoPorSubrogacion"] = "13";
    FormaPago["PagoPorConsignacion"] = "14";
    FormaPago["Condonacion"] = "15";
    FormaPago["Compensacion"] = "17";
    FormaPago["Novacion"] = "23";
    FormaPago["Confusion"] = "24";
    FormaPago["RemisionDeDeuda"] = "25";
    FormaPago["PrescripcionOCaducidad"] = "26";
    FormaPago["ASatisfaccionDelAcreedor"] = "27";
    FormaPago["TarjetaDeDebito"] = "28";
    FormaPago["TarjetaDeServicios"] = "29";
    FormaPago["AplicacionDeAnticipos"] = "30";
    FormaPago["IntermediarioPagos"] = "31";
    FormaPago["PorDefinir"] = "99";
})(FormaPago = exports.FormaPago || (exports.FormaPago = {}));
var Impuesto;
(function (Impuesto) {
    Impuesto["ISR"] = "001";
    Impuesto["IVA"] = "002";
    Impuesto["IEPS"] = "003";
})(Impuesto = exports.Impuesto || (exports.Impuesto = {}));
var Meses;
(function (Meses) {
    Meses["Enero"] = "01";
    Meses["Febrero"] = "02";
    Meses["Marzo"] = "03";
    Meses["Abril"] = "04";
    Meses["Mayo"] = "05";
    Meses["Junio"] = "06";
    Meses["Julio"] = "07";
    Meses["Agosto"] = "08";
    Meses["Septiembre"] = "09";
    Meses["Octubre"] = "10";
    Meses["Noviembre"] = "11";
    Meses["Diciembre"] = "12";
    Meses["Eneroebrero"] = "13";
    Meses["Marzobril"] = "14";
    Meses["Mayounio"] = "15";
    Meses["Juliogosto"] = "16";
    Meses["Septiembrectubre"] = "17";
    Meses["Noviembreiciembre"] = "18";
})(Meses = exports.Meses || (exports.Meses = {}));
var MetodoPago;
(function (MetodoPago) {
    MetodoPago["PagoEnUnaSolaExhibicion"] = "PUE";
    MetodoPago["PagoEnParcialidadesODiferido"] = "PPD";
})(MetodoPago = exports.MetodoPago || (exports.MetodoPago = {}));
var Moneda;
(function (Moneda) {
    Moneda["DirhamDeEau"] = "AED";
    Moneda["Afghani"] = "AFN";
    Moneda["Lek"] = "ALL";
    Moneda["DramArmenio"] = "AMD";
    Moneda["FlorinAntillanoNeerlandes"] = "ANG";
    Moneda["Kwanza"] = "AOA";
    Moneda["PesoArgentino"] = "ARS";
    Moneda["DolarAustraliano"] = "AUD";
    Moneda["ArubaFlorin"] = "AWG";
    Moneda["AzerbaijanianManat"] = "AZN";
    Moneda["ConvertiblesMarca"] = "BAM";
    Moneda["DolarDeBarbados"] = "BBD";
    Moneda["Taka"] = "BDT";
    Moneda["LevBulgaro"] = "BGN";
    Moneda["DinarDeBahrein"] = "BHD";
    Moneda["BurundiFranc"] = "BIF";
    Moneda["DolarDeBermudas"] = "BMD";
    Moneda["DolarDeBrunei"] = "BND";
    Moneda["Boliviano"] = "BOB";
    Moneda["Mvdol"] = "BOV";
    Moneda["RealBrasile\u00F1o"] = "BRL";
    Moneda["DolarDeLasBahamas"] = "BSD";
    Moneda["Ngultrum"] = "BTN";
    Moneda["Pula"] = "BWP";
    Moneda["RubloBielorruso"] = "BYR";
    Moneda["DolarDeBelice"] = "BZD";
    Moneda["DolarCanadiense"] = "CAD";
    Moneda["FrancoCongole\u00F1o"] = "CDF";
    Moneda["WirEuro"] = "CHE";
    Moneda["FrancoSuizo"] = "CHF";
    Moneda["FrancWir"] = "CHW";
    Moneda["UnidadDeFomento"] = "CLF";
    Moneda["PesoChileno"] = "CLP";
    Moneda["YuanRenminbi"] = "CNY";
    Moneda["PesoColombiano"] = "COP";
    Moneda["UnidadDeValorReal"] = "COU";
    Moneda["ColonCostarricense"] = "CRC";
    Moneda["PesoConvertible"] = "CUC";
    Moneda["PesoCubano"] = "CUP";
    Moneda["CaboVerdeEscudo"] = "CVE";
    Moneda["CoronaCheca"] = "CZK";
    Moneda["FrancoDeDjibouti"] = "DJF";
    Moneda["CoronaDanesa"] = "DKK";
    Moneda["PesoDominicano"] = "DOP";
    Moneda["DinarArgelino"] = "DZD";
    Moneda["LibraEgipcia"] = "EGP";
    Moneda["Nakfa"] = "ERN";
    Moneda["BirrEtiope"] = "ETB";
    Moneda["Euro"] = "EUR";
    Moneda["DolarDeFiji"] = "FJD";
    Moneda["LibraMalvinense"] = "FKP";
    Moneda["LibraEsterlina"] = "GBP";
    Moneda["Lari"] = "GEL";
    Moneda["CediDeGhana"] = "GHS";
    Moneda["LibraDeGibraltar"] = "GIP";
    Moneda["Dalasi"] = "GMD";
    Moneda["FrancoGuineano"] = "GNF";
    Moneda["Quetzal"] = "GTQ";
    Moneda["DolarGuyanes"] = "GYD";
    Moneda["DolarDeHongKong"] = "HKD";
    Moneda["Lempira"] = "HNL";
    Moneda["Kuna"] = "HRK";
    Moneda["Gourde"] = "HTG";
    Moneda["Florin"] = "HUF";
    Moneda["RupiaIDR"] = "IDR";
    Moneda["NuevoShekelIsraeli"] = "ILS";
    Moneda["RupiaIndia"] = "INR";
    Moneda["DinarIraqui"] = "IQD";
    Moneda["RialIrani"] = "IRR";
    Moneda["CoronaIslandesa"] = "ISK";
    Moneda["DolarJamaiquino"] = "JMD";
    Moneda["DinarJordano"] = "JOD";
    Moneda["Yen"] = "JPY";
    Moneda["ChelinKeniano"] = "KES";
    Moneda["Som"] = "KGS";
    Moneda["Riel"] = "KHR";
    Moneda["FrancoComoro"] = "KMF";
    Moneda["CoreaDelNorteGano"] = "KPW";
    Moneda["Won"] = "KRW";
    Moneda["DinarKuwaiti"] = "KWD";
    Moneda["DolarDeLasIslasCaiman"] = "KYD";
    Moneda["Tenge"] = "KZT";
    Moneda["Kip"] = "LAK";
    Moneda["LibraLibanesa"] = "LBP";
    Moneda["RupiaDeSriLanka"] = "LKR";
    Moneda["DolarLiberiano"] = "LRD";
    Moneda["Loti"] = "LSL";
    Moneda["DinarLibio"] = "LYD";
    Moneda["DirhamMarroqui"] = "MAD";
    Moneda["LeuMoldavo"] = "MDL";
    Moneda["AriaryMalgache"] = "MGA";
    Moneda["Denar"] = "MKD";
    Moneda["Kyat"] = "MMK";
    Moneda["Tugrik"] = "MNT";
    Moneda["Pataca"] = "MOP";
    Moneda["Ouguiya"] = "MRO";
    Moneda["RupiaDeMauricio"] = "MUR";
    Moneda["Rupia"] = "MVR";
    Moneda["Kwacha"] = "MWK";
    Moneda["PesoMexicano"] = "MXN";
    Moneda["MexicoUnidadDeInversionudi"] = "MXV";
    Moneda["RinggitMalayo"] = "MYR";
    Moneda["MozambiqueMetical"] = "MZN";
    Moneda["DolarDeNamibia"] = "NAD";
    Moneda["Naira"] = "NGN";
    Moneda["CordobaOro"] = "NIO";
    Moneda["CoronaNoruega"] = "NOK";
    Moneda["RupiaNepali"] = "NPR";
    Moneda["DolarDeNuevaZelanda"] = "NZD";
    Moneda["RialOmani"] = "OMR";
    Moneda["Balboa"] = "PAB";
    Moneda["NuevoSol"] = "PEN";
    Moneda["Kina"] = "PGK";
    Moneda["PesoFilipino"] = "PHP";
    Moneda["RupiaDePakistan"] = "PKR";
    Moneda["Zloty"] = "PLN";
    Moneda["Guarani"] = "PYG";
    Moneda["QatarRial"] = "QAR";
    Moneda["LeuRumano"] = "RON";
    Moneda["DinarSerbio"] = "RSD";
    Moneda["RubloRuso"] = "RUB";
    Moneda["FrancoRuandes"] = "RWF";
    Moneda["RiyalSaudi"] = "SAR";
    Moneda["DolarDeLasIslasSalomon"] = "SBD";
    Moneda["RupiaDeSeychelles"] = "SCR";
    Moneda["LibraSudanesa"] = "SDG";
    Moneda["CoronaSueca"] = "SEK";
    Moneda["DolarDeSingapur"] = "SGD";
    Moneda["LibraDeSantaHelena"] = "SHP";
    Moneda["Leona"] = "SLL";
    Moneda["ChelinSomali"] = "SOS";
    Moneda["DolarDeSuriname"] = "SRD";
    Moneda["LibraSudanesaSur"] = "SSP";
    Moneda["Dobra"] = "STD";
    Moneda["ColonElSalvador"] = "SVC";
    Moneda["LibraSiria"] = "SYP";
    Moneda["Lilangeni"] = "SZL";
    Moneda["Baht"] = "THB";
    Moneda["Somoni"] = "TJS";
    Moneda["TurkmenistanNuevoManat"] = "TMT";
    Moneda["DinarTunecino"] = "TND";
    Moneda["Paanga"] = "TOP";
    Moneda["LiraTurca"] = "TRY";
    Moneda["DolarDeTrinidadYTobago"] = "TTD";
    Moneda["NuevoDolarDeTaiwan"] = "TWD";
    Moneda["ShillingTanzano"] = "TZS";
    Moneda["Hryvnia"] = "UAH";
    Moneda["ShillingDeUganda"] = "UGX";
    Moneda["DolarAmericano"] = "USD";
    Moneda["DolarEstadounidensediaSiguiente"] = "USN";
    Moneda["PesoUruguayEnUnidadesIndexadasuruiurui"] = "UYI";
    Moneda["PesoUruguayo"] = "UYU";
    Moneda["UzbekistanSum"] = "UZS";
    Moneda["Bolivar"] = "VEF";
    Moneda["Dong"] = "VND";
    Moneda["Vatu"] = "VUV";
    Moneda["Tala"] = "WST";
    Moneda["FrancoCfaBeac"] = "XAF";
    Moneda["Plata"] = "XAG";
    Moneda["Oro"] = "XAU";
    Moneda["UnidadDeMercadosDeBonosUnidadEuropeaCompositeeurco"] = "XBA";
    Moneda["UnidadMonetariaDeBonosDeMercadosUnidadEuropeauem"] = "XBB";
    Moneda["MercadosDeBonosUnidadEuropeaUnidadDeCuentaANueve"] = "XBC";
    Moneda["MercadosDeBonosUnidadEuropeaUnidadDeCuentaADiecisiete"] = "XBD";
    Moneda["DolarDelCaribeOriental"] = "XCD";
    Moneda["DegderechosEspecialesDeGiro"] = "XDR";
    Moneda["FrancoCfaBceao"] = "XOF";
    Moneda["Paladio"] = "XPD";
    Moneda["FrancoCfp"] = "XPF";
    Moneda["Platino"] = "XPT";
    Moneda["Sucre"] = "XSU";
    Moneda["CodigosReservadosEspecificamenteParaPropositosDePrueba"] = "XTS";
    Moneda["UnidadAdbDeCuenta"] = "XUA";
    Moneda["LosCodigosAsignadosParaLasTransaccionesEnQueIntervengaNingunaMoneda"] = "XXX";
    Moneda["RialYemeni"] = "YER";
    Moneda["Rand"] = "ZAR";
    Moneda["KwachaZambiano"] = "ZMW";
    Moneda["ZimbabweDolar"] = "ZWL";
})(Moneda = exports.Moneda || (exports.Moneda = {}));
var ObjetoImp;
(function (ObjetoImp) {
    ObjetoImp["NoObjetoDeImpuesto"] = "01";
    ObjetoImp["SiObjetoDeImpuesto"] = "02";
    ObjetoImp["SiObjetoDelImpuestoYNoObligadoAlDesglose"] = "03";
})(ObjetoImp = exports.ObjetoImp || (exports.ObjetoImp = {}));
var Pais;
(function (Pais) {
    Pais["Afganistan"] = "AFG";
    Pais["Islas\u00C5land"] = "ALA";
    Pais["Albania"] = "ALB";
    Pais["Alemania"] = "DEU";
    Pais["Andorra"] = "AND";
    Pais["Angola"] = "AGO";
    Pais["Anguila"] = "AIA";
    Pais["Antartida"] = "ATA";
    Pais["AntiguaYBarbuda"] = "ATG";
    Pais["ArabiaSaudita"] = "SAU";
    Pais["Argelia"] = "DZA";
    Pais["Argentina"] = "ARG";
    Pais["Armenia"] = "ARM";
    Pais["Aruba"] = "ABW";
    Pais["Australia"] = "AUS";
    Pais["Austria"] = "AUT";
    Pais["Azerbaiyan"] = "AZE";
    Pais["Bahamaslas"] = "BHS";
    Pais["Banglades"] = "BGD";
    Pais["Barbados"] = "BRB";
    Pais["Barein"] = "BHR";
    Pais["Belgica"] = "BEL";
    Pais["Belice"] = "BLZ";
    Pais["Benin"] = "BEN";
    Pais["Bermudas"] = "BMU";
    Pais["Bielorrusia"] = "BLR";
    Pais["Myanmar"] = "MMR";
    Pais["BoliviastadoPlurinacionalDe"] = "BOL";
    Pais["BosniaYHerzegovina"] = "BIH";
    Pais["Botsuana"] = "BWA";
    Pais["Brasil"] = "BRA";
    Pais["BruneiDarussalam"] = "BRN";
    Pais["Bulgaria"] = "BGR";
    Pais["BurkinaFaso"] = "BFA";
    Pais["Burundi"] = "BDI";
    Pais["Butan"] = "BTN";
    Pais["CaboVerde"] = "CPV";
    Pais["Camboya"] = "KHM";
    Pais["Camerun"] = "CMR";
    Pais["Canada"] = "CAN";
    Pais["Catar"] = "QAT";
    Pais["BonaireanEustaquioYSaba"] = "BES";
    Pais["Chad"] = "TCD";
    Pais["Chile"] = "CHL";
    Pais["China"] = "CHN";
    Pais["Chipre"] = "CYP";
    Pais["Colombia"] = "COL";
    Pais["Comoras"] = "COM";
    Pais["CorealaRepublicaDemocraticaPopularDe"] = "PRK";
    Pais["CorealaRepublicaDe"] = "KOR";
    Pais["COteDivoire"] = "CIV";
    Pais["CostaRica"] = "CRI";
    Pais["Croacia"] = "HRV";
    Pais["Cuba"] = "CUB";
    Pais["Cura\u00E7ao"] = "CUW";
    Pais["Dinamarca"] = "DNK";
    Pais["Dominica"] = "DMA";
    Pais["Ecuador"] = "ECU";
    Pais["Egipto"] = "EGY";
    Pais["ElSalvador"] = "SLV";
    Pais["EmiratosarabesUnidoslos"] = "ARE";
    Pais["Eritrea"] = "ERI";
    Pais["Eslovaquia"] = "SVK";
    Pais["Eslovenia"] = "SVN";
    Pais["Espa\u00F1a"] = "ESP";
    Pais["EstadosUnidoslos"] = "USA";
    Pais["Estonia"] = "EST";
    Pais["Etiopia"] = "ETH";
    Pais["Filipinaslas"] = "PHL";
    Pais["Finlandia"] = "FIN";
    Pais["Fiyi"] = "FJI";
    Pais["Francia"] = "FRA";
    Pais["Gabon"] = "GAB";
    Pais["Gambiala"] = "GMB";
    Pais["Georgia"] = "GEO";
    Pais["Ghana"] = "GHA";
    Pais["Gibraltar"] = "GIB";
    Pais["Granada"] = "GRD";
    Pais["Grecia"] = "GRC";
    Pais["Groenlandia"] = "GRL";
    Pais["Guadalupe"] = "GLP";
    Pais["Guam"] = "GUM";
    Pais["Guatemala"] = "GTM";
    Pais["GuayanaFrancesa"] = "GUF";
    Pais["Guernsey"] = "GGY";
    Pais["Guinea"] = "GIN";
    Pais["Guineaisau"] = "GNB";
    Pais["GuineaEcuatorial"] = "GNQ";
    Pais["Guyana"] = "GUY";
    Pais["Haiti"] = "HTI";
    Pais["Honduras"] = "HND";
    Pais["HongKong"] = "HKG";
    Pais["Hungria"] = "HUN";
    Pais["India"] = "IND";
    Pais["Indonesia"] = "IDN";
    Pais["Irak"] = "IRQ";
    Pais["IranlaRepublicaIslamicaDe"] = "IRN";
    Pais["Irlanda"] = "IRL";
    Pais["IslaBouvet"] = "BVT";
    Pais["IslaDeMan"] = "IMN";
    Pais["IslaDeNavidad"] = "CXR";
    Pais["IslaNorfolk"] = "NFK";
    Pais["Islandia"] = "ISL";
    Pais["IslasCaimanlas"] = "CYM";
    Pais["IslasCocoskeeling"] = "CCK";
    Pais["IslasCooklas"] = "COK";
    Pais["IslasFeroelas"] = "FRO";
    Pais["GeorgiaDelSurYLasIslasSandwichDelSur"] = "SGS";
    Pais["IslaHeardEIslasMcdonald"] = "HMD";
    Pais["IslasMalvinasfalklandlas"] = "FLK";
    Pais["IslasMarianasDelNortelas"] = "MNP";
    Pais["IslasMarshalllas"] = "MHL";
    Pais["Pitcairn"] = "PCN";
    Pais["IslasSalomonlas"] = "SLB";
    Pais["IslasTurcasYCaicoslas"] = "TCA";
    Pais["IslasDeUltramarMenoresDeEstadosUnidoslas"] = "UMI";
    Pais["IslasVirgenesbritanicas"] = "VGB";
    Pais["IslasVirgeneseeuu"] = "VIR";
    Pais["Israel"] = "ISR";
    Pais["Italia"] = "ITA";
    Pais["Jamaica"] = "JAM";
    Pais["Japon"] = "JPN";
    Pais["Jersey"] = "JEY";
    Pais["Jordania"] = "JOR";
    Pais["Kazajistan"] = "KAZ";
    Pais["Kenia"] = "KEN";
    Pais["Kirguistan"] = "KGZ";
    Pais["Kiribati"] = "KIR";
    Pais["Kuwait"] = "KWT";
    Pais["LaoaRepublicaDemocraticaPopular"] = "LAO";
    Pais["Lesoto"] = "LSO";
    Pais["Letonia"] = "LVA";
    Pais["Libano"] = "LBN";
    Pais["Liberia"] = "LBR";
    Pais["Libia"] = "LBY";
    Pais["Liechtenstein"] = "LIE";
    Pais["Lituania"] = "LTU";
    Pais["Luxemburgo"] = "LUX";
    Pais["Macao"] = "MAC";
    Pais["Madagascar"] = "MDG";
    Pais["Malasia"] = "MYS";
    Pais["Malaui"] = "MWI";
    Pais["Maldivas"] = "MDV";
    Pais["Mali"] = "MLI";
    Pais["Malta"] = "MLT";
    Pais["Marruecos"] = "MAR";
    Pais["Martinica"] = "MTQ";
    Pais["Mauricio"] = "MUS";
    Pais["Mauritania"] = "MRT";
    Pais["Mayotte"] = "MYT";
    Pais["Mexico"] = "MEX";
    Pais["MicronesialosEstadosFederadosDe"] = "FSM";
    Pais["MoldavialaRepublicaDe"] = "MDA";
    Pais["Monaco"] = "MCO";
    Pais["Mongolia"] = "MNG";
    Pais["Montenegro"] = "MNE";
    Pais["Montserrat"] = "MSR";
    Pais["Mozambique"] = "MOZ";
    Pais["Namibia"] = "NAM";
    Pais["Nauru"] = "NRU";
    Pais["Nepal"] = "NPL";
    Pais["Nicaragua"] = "NIC";
    Pais["Nigerel"] = "NER";
    Pais["Nigeria"] = "NGA";
    Pais["Niue"] = "NIU";
    Pais["Noruega"] = "NOR";
    Pais["NuevaCaledonia"] = "NCL";
    Pais["NuevaZelanda"] = "NZL";
    Pais["Oman"] = "OMN";
    Pais["PaisesBajoslos"] = "NLD";
    Pais["Pakistan"] = "PAK";
    Pais["Palaos"] = "PLW";
    Pais["PalestinastadoDe"] = "PSE";
    Pais["Panama"] = "PAN";
    Pais["PapuaNuevaGuinea"] = "PNG";
    Pais["Paraguay"] = "PRY";
    Pais["Peru"] = "PER";
    Pais["PolinesiaFrancesa"] = "PYF";
    Pais["Polonia"] = "POL";
    Pais["Portugal"] = "PRT";
    Pais["PuertoRico"] = "PRI";
    Pais["ReinoUnidoel"] = "GBR";
    Pais["RepublicaCentroafricanala"] = "CAF";
    Pais["RepublicaChecala"] = "CZE";
    Pais["MacedonialaAntiguaRepublicaYugoslavaDe"] = "MKD";
    Pais["Congo"] = "COG";
    Pais["CongolaRepublicaDemocraticaDel"] = "COD";
    Pais["RepublicaDominicanala"] = "DOM";
    Pais["Reunion"] = "REU";
    Pais["Ruanda"] = "RWA";
    Pais["Rumania"] = "ROU";
    Pais["RusiaaFederacionDe"] = "RUS";
    Pais["SaharaOccidental"] = "ESH";
    Pais["Samoa"] = "WSM";
    Pais["SamoaAmericana"] = "ASM";
    Pais["SanBartolome"] = "BLM";
    Pais["SanCristobalYNieves"] = "KNA";
    Pais["SanMarino"] = "SMR";
    Pais["SanMartinparteFrancesa"] = "MAF";
    Pais["SanPedroYMiquelon"] = "SPM";
    Pais["SanVicenteYLasGranadinas"] = "VCT";
    Pais["SantaHelenascensionYTristanDeAcu\u00F1a"] = "SHN";
    Pais["SantaLucia"] = "LCA";
    Pais["SantoTomeYPrincipe"] = "STP";
    Pais["Senegal"] = "SEN";
    Pais["Serbia"] = "SRB";
    Pais["Seychelles"] = "SYC";
    Pais["SierraLeona"] = "SLE";
    Pais["Singapur"] = "SGP";
    Pais["SintMaartenparteHolandesa"] = "SXM";
    Pais["SiriaaRepublicaarabe"] = "SYR";
    Pais["Somalia"] = "SOM";
    Pais["SriLanka"] = "LKA";
    Pais["Suazilandia"] = "SWZ";
    Pais["Sudafrica"] = "ZAF";
    Pais["Sudanel"] = "SDN";
    Pais["SudanDelSur"] = "SSD";
    Pais["Suecia"] = "SWE";
    Pais["Suiza"] = "CHE";
    Pais["Surinam"] = "SUR";
    Pais["SvalbardYJanMayen"] = "SJM";
    Pais["Tailandia"] = "THA";
    Pais["TaiwanprovinciaDeChina"] = "TWN";
    Pais["TanzaniaepublicaUnidaDe"] = "TZA";
    Pais["Tayikistan"] = "TJK";
    Pais["TerritorioBritanicoDelOceanoindicoel"] = "IOT";
    Pais["TerritoriosAustralesFranceseslos"] = "ATF";
    Pais["Timoreste"] = "TLS";
    Pais["Togo"] = "TGO";
    Pais["Tokelau"] = "TKL";
    Pais["Tonga"] = "TON";
    Pais["TrinidadYTobago"] = "TTO";
    Pais["Tunez"] = "TUN";
    Pais["Turkmenistan"] = "TKM";
    Pais["Turquia"] = "TUR";
    Pais["Tuvalu"] = "TUV";
    Pais["Ucrania"] = "UKR";
    Pais["Uganda"] = "UGA";
    Pais["Uruguay"] = "URY";
    Pais["Uzbekistan"] = "UZB";
    Pais["Vanuatu"] = "VUT";
    Pais["SantaSedeestadoDeLaCiudadDelVaticanola"] = "VAT";
    Pais["VenezuelaepublicaBolivarianaDe"] = "VEN";
    Pais["VietNam"] = "VNM";
    Pais["WallisYFutuna"] = "WLF";
    Pais["Yemen"] = "YEM";
    Pais["Yibuti"] = "DJI";
    Pais["Zambia"] = "ZMB";
    Pais["Zimbabue"] = "ZWE";
    Pais["PaisesNoDeclarados"] = "ZZZ";
})(Pais = exports.Pais || (exports.Pais = {}));
var Periodicidad;
(function (Periodicidad) {
    Periodicidad["Diario"] = "01";
    Periodicidad["Semanal"] = "02";
    Periodicidad["Quincenal"] = "03";
    Periodicidad["Mensual"] = "04";
    Periodicidad["Bimestral"] = "05";
})(Periodicidad = exports.Periodicidad || (exports.Periodicidad = {}));
var RegimenFiscal;
(function (RegimenFiscal) {
    RegimenFiscal["GeneralDeLeyPersonasMorales"] = "601";
    RegimenFiscal["PersonasMoralesConFinesNoLucrativos"] = "603";
    RegimenFiscal["SueldosYSalariosEIngresosAsimiladosASalarios"] = "605";
    RegimenFiscal["Arrendamiento"] = "606";
    RegimenFiscal["RegimenDeEnajenacionOAdquisicionDeBienes"] = "607";
    RegimenFiscal["DemasIngresos"] = "608";
    RegimenFiscal["ResidentesEnElExtranjeroSinEstablecimientoPermanenteEnMexico"] = "610";
    RegimenFiscal["IngresosPorDividendossociosYAccionistas"] = "611";
    RegimenFiscal["PersonasFisicasConActividadesEmpresarialesYProfesionales"] = "612";
    RegimenFiscal["IngresosPorIntereses"] = "614";
    RegimenFiscal["RegimenDeLosIngresosPorObtencionDePremios"] = "615";
    RegimenFiscal["SinObligacionesFiscales"] = "616";
    RegimenFiscal["SociedadesCooperativasDeProduccionQueOptanPorDiferirSusIngresos"] = "620";
    RegimenFiscal["IncorporacionFiscal"] = "621";
    RegimenFiscal["ActividadesAgricolasanaderasilvicolasYPesqueras"] = "622";
    RegimenFiscal["OpcionalParaGruposDeSociedades"] = "623";
    RegimenFiscal["Coordinados"] = "624";
    RegimenFiscal["RegimenDeLasActividadesEmpresarialesConIngresosATravesDePlataformasTecnologicas"] = "625";
    RegimenFiscal["RegimenSimplificadoDeConfianza"] = "626";
})(RegimenFiscal = exports.RegimenFiscal || (exports.RegimenFiscal = {}));
var TipoDeComprobante;
(function (TipoDeComprobante) {
    TipoDeComprobante["Ingreso"] = "I";
    TipoDeComprobante["Egreso"] = "E";
    TipoDeComprobante["Traslado"] = "T";
    TipoDeComprobante["Nomina"] = "N";
    TipoDeComprobante["Pago"] = "P";
})(TipoDeComprobante = exports.TipoDeComprobante || (exports.TipoDeComprobante = {}));
var TipoFactor;
(function (TipoFactor) {
    TipoFactor["tasa"] = "Tasa";
    TipoFactor["cuota"] = "Cuota";
    TipoFactor["exento"] = "Exento";
})(TipoFactor = exports.TipoFactor || (exports.TipoFactor = {}));
var TipoRelacion;
(function (TipoRelacion) {
    TipoRelacion["NotaDeCreditoDeLosDocumentosRelacionados"] = "01";
    TipoRelacion["NotaDeDebitoDeLosDocumentosRelacionados"] = "02";
    TipoRelacion["DevolucionDeMercanciaSobreFacturasOTrasladosPrevios"] = "03";
    TipoRelacion["SustitucionDeLosCfdiPrevios"] = "04";
    TipoRelacion["TrasladosDeMercanciasFacturadosPreviamente"] = "05";
    TipoRelacion["FacturaGeneradaPorLosTrasladosPrevios"] = "06";
    TipoRelacion["CfdiPorAplicacionDeAnticipo"] = "07";
})(TipoRelacion = exports.TipoRelacion || (exports.TipoRelacion = {}));
var UsoCFDI;
(function (UsoCFDI) {
    UsoCFDI["AdquisicionDeMercancias"] = "G01";
    UsoCFDI["DevolucionesescuentosOBonificaciones"] = "G02";
    UsoCFDI["GastosEnGeneral"] = "G03";
    UsoCFDI["Construcciones"] = "I01";
    UsoCFDI["MobiliarioYEquipoDeOficinaPorInversiones"] = "I02";
    UsoCFDI["EquipoDeTransporte"] = "I03";
    UsoCFDI["EquipoDeComputoYAccesorios"] = "I04";
    UsoCFDI["DadosroquelesoldesatricesYHerramental"] = "I05";
    UsoCFDI["ComunicacionesTelefonicas"] = "I06";
    UsoCFDI["ComunicacionesSatelitales"] = "I07";
    UsoCFDI["OtraMaquinariaYEquipo"] = "I08";
    UsoCFDI["HonorariosMedicosentalesYGastosHospitalarios"] = "D01";
    UsoCFDI["GastosMedicosPorIncapacidadODiscapacidad"] = "D02";
    UsoCFDI["GastosFunerales"] = "D03";
    UsoCFDI["Donativos"] = "D04";
    UsoCFDI["InteresesRealesEfectivamentePagadosPorCreditosHipotecarioscasaHabitacion"] = "D05";
    UsoCFDI["AportacionesVoluntariasAlSar"] = "D06";
    UsoCFDI["PrimasPorSegurosDeGastosMedicos"] = "D07";
    UsoCFDI["GastosDeTransportacionEscolarObligatoria"] = "D08";
    UsoCFDI["DepositosEnCuentasParaElAhorrorimasQueTenganComoBasePlanesDePensiones"] = "D09";
    UsoCFDI["PagosPorServiciosEducativoscolegiaturas"] = "D10";
    UsoCFDI["SinEfectosFiscales"] = "S01";
    UsoCFDI["Pagos"] = "CP01";
    UsoCFDI["Nomina"] = "CN01";
})(UsoCFDI = exports.UsoCFDI || (exports.UsoCFDI = {}));
var ClaveProdServ;
(function (ClaveProdServ) {
    ClaveProdServ["NoExisteEnElCatalogo"] = "01010101";
})(ClaveProdServ = exports.ClaveProdServ || (exports.ClaveProdServ = {}));
var ClaveUnidad;
(function (ClaveUnidad) {
    ClaveUnidad["Peque\u00F1oAerosol"] = "06";
})(ClaveUnidad = exports.ClaveUnidad || (exports.ClaveUnidad = {}));
//# sourceMappingURL=catalagosEnum.js.map